export default __webpack_public_path__ + "static/media/sos-dia-04-11.8aed8af5.webp";